export const DEFAULT_MAX_TRIAL_DAYS = 7;

export const maxTrialDaysFor = (userData = {}) => {
  const days = Number(userData?.max_trial_days);
  return days > 0 ? days : DEFAULT_MAX_TRIAL_DAYS;
};

export const canStartMaxUpgradeTrial = (userData = {}) => {
  const billingPlanTier =
    userData?.billing_subscription_plan_tier || userData?.subscription_plan_tier;

  return (
    userData?.user_id != null &&
    !userData?.is_admin_user &&
    billingPlanTier !== "max" &&
    userData?.max_trial_eligible === true &&
    !userData?.max_trial_active
  );
};

export const shouldUseMaxTrialMode = ({
  maxTrialEligible,
  maxTrialRequested,
  trialIsActive,
  userData = {},
  userDataResolved,
} = {}) => (
  Boolean(trialIsActive) ||
  (Boolean(maxTrialRequested) && !userDataResolved) ||
  (
    Boolean(maxTrialRequested) &&
    canStartMaxUpgradeTrial({
      ...userData,
      max_trial_eligible: maxTrialEligible,
    })
  )
);

export const shouldShowMaxUpgradeCta = (userData = {}) => {
  const billingPlanTier =
    userData?.billing_subscription_plan_tier || userData?.subscription_plan_tier;
  const nonMaxStripeSubscriber =
    Boolean(userData?.has_active_subscription) &&
    userData?.subscription_provider === "stripe" &&
    billingPlanTier !== "max";

  return (
    nonMaxStripeSubscriber &&
    ["active", "trialing"].includes(userData?.subscription_status) &&
    !userData?.max_trial_active
  );
};

export const maxUpgradePathFor = (userData = {}) =>
  canStartMaxUpgradeTrial(userData)
    ? "/plan-selection?max_trial=1#max"
    : "/plan-selection#max";

export const maxUpgradeButtonLabelFor = (userData = {}) =>
  canStartMaxUpgradeTrial(userData) ? "Try Max" : "Go Max";

export const maxTrialPrimaryLabelFor = (userData = {}) =>
  `Try MAX ${maxTrialDaysFor(userData)} Days Free`;

export const buildMaxUpgradeModalProps = (userData = {}, copy = {}) => {
  if (!canStartMaxUpgradeTrial(userData)) {
    return {
      eyebrow: copy.eyebrow || "Incite Max",
      title: copy.title,
      description: copy.description,
      bullets: copy.bullets,
      footer: copy.footer,
      primaryLabel: copy.primaryLabel || "Get Max",
      secondaryLabel: copy.secondaryLabel,
    };
  }

  const days = maxTrialDaysFor(userData);
  const activeProSubscription = Boolean(userData?.has_active_subscription);

  return {
    eyebrow: `${days}-Day MAX Trial`,
    title: copy.trialTitle || `Try MAX free for ${days} days.`,
    description: copy.trialDescription || copy.description,
    bullets: copy.trialBullets || copy.bullets,
    footer:
      copy.trialFooter ||
      (activeProSubscription
        ? `Today is $0. Your Pro subscription stays active during the ${days}-day trial.`
        : `Today is $0. No payment is collected. Choose a paid MAX plan after the ${days}-day trial to keep MAX access.`),
    primaryLabel: copy.trialPrimaryLabel || maxTrialPrimaryLabelFor(userData),
    secondaryLabel: copy.secondaryLabel,
  };
};
